import React, { useState, useEffect } from "react";
import "./intro.css";
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { realtimeDatabase } from "../../database/firebase";
import { getFirestore, increment, serverTimestamp, doc, getDoc, updateDoc, addDoc, setDoc, collection, query, orderBy, where, getDocs, onSnapshot, listCollections, Timestamp } from "firebase/firestore";
import axios from "axios";


function Intro({ updateHeader }) {
  const navigate = useNavigate();
  const location = useLocation();
  const [userData, setUserData] = useState(null);
  const [themeData, setThemeData] = useState(null);
  const [riddlerusLogo, SetriddlerusLogo] = useState("/img/logo.png");
  const storedUserData = JSON.parse(sessionStorage.getItem('userData'));
  //const themeData1 = JSON.parse(sessionStorage.getItem('themeData'));
  const [rules, setRules] = useState(["", "", ""]);
  const [textcolor, Setcolorcode] = useState(null);
  const [apiGametype, setApiGametype] = useState(null);
  const [tournamentType, setTournamentType] = useState(null);
  const [tournamentTypes, setTournamentTypes] = useState([]);


  useEffect(() => {

    updateHeader({
      backButtonRedirect: "/login"
    });

    const fetchData = async () => {
      const storedSession = sessionStorage.getItem("userData");
      console.log(storedSession);
            const storedTheme = sessionStorage.getItem("themeData");

      if (storedSession && storedTheme) {
        const parsedUser = JSON.parse(storedSession);
        const parsedTheme = JSON.parse(storedTheme);

        setUserData(parsedUser);
        setThemeData(parsedTheme);
        Setcolorcode(parsedTheme.landing_page_title_color);
      } else {
      navigate("/login");
      }
    };

    fetchData();
  }, [navigate]);

  useEffect(() => {
    if (!userData?.sessionId || !userData?.organizationId) return;
    const fetchMatchType = async () => {
      try {
        const res = await axios.post(
          `${process.env.REACT_APP_PHP_ADMIN_BASE_URL}getMatchType.php`,
          {
            sessionId: userData.sessionId,
            organizationId: userData.organizationId,
          },
          { headers: { 'Content-Type': 'application/json' } }
        );
        const data = res?.data?.data;
        console.log(data);
        const success = res?.data?.response?.success;
        if (success && data?.gametype) {
          setApiGametype(data.gametype);
          
        } 
      } catch (err) {
        console.error('getMatchType error:', err);
        setApiGametype(null);
      }
    };
    fetchMatchType();
  }, [userData?.sessionId, userData?.organizationId, userData?.gameId]);

  useEffect(() => {
    if (!userData?.sessionId) return;
    const fetchTournament = async () => {
      try {
        const res = await axios.post(
          `${process.env.REACT_APP_PHP_ADMIN_BASE_URL}fetchTournament.php`,
          {
            sessionId: userData.sessionId,
            organizationId: userData.organizationId,
          },
          { headers: { 'Content-Type': 'application/json' } }
        );
        const data = res?.data?.data;
        const success = res?.data?.response?.success;
        if (success && data) {
          setTournamentType(data.tournamentType || null);
          setTournamentTypes(data.tournamentTypes || []);
        } else {
          setTournamentType(null);
          setTournamentTypes([]);
        }
      } catch (err) {
        console.error('fetchTournament error:', err);
        setTournamentType(null);
        setTournamentTypes([]);
      }
    };
    fetchTournament();
  }, [userData?.sessionId, userData?.organizationId]);

  const smartTournamentRules = [
    "Each participant will play 4 matches, with one match scheduled on different days.",
    "Points are awarded as follows:",
    "🏆 Win: You earn 1 point for every coin left with your opponent at the end of the match, plus 3 bonus points if you pocket the Queen.",
    "❌ Loss: 0 points.",
    "If you leave or disconnect before the match ends, your opponent will receive points based on the number of your remaining coins.",
    "Players must join their match within 10 minutes of the scheduled start time.",
    "If a player does not join within the grace period, they will be disqualified from the tournament, and their opponent will be awarded the win for that match.",
    "Once a match has been scheduled, it cannot be rescheduled.",
    "After everyone has completed all 4 matches, the Top 4 players with the highest total points will qualify for the Semi Finals.",
    "The winners of the Semi Finals will compete in the Final.",
    "🏆 The winner of the Final will be crowned the Tournament Champion!",
    "If you pocket your opponent’s last coin while the Queen is still on the board, your opponent wins.",
    "If your opponent accidentally pockets your final cover coin while you are covering the Queen, leaving you with no coins, you win.",
    "If you pocket your last coin before covering the Queen, your opponent wins.",
    "If both colours are cleared in the same shot, the player taking the shot wins.",
    "If only one colour is cleared, the player who owns that colour wins, provided the Queen has been validly pocketed and covered.",
    "If you clear all your coins without the Queen being validly pocketed and covered, your opponent wins.",
    "Important:",
    "The system's decision will be final in all cases.",
    "For the best experience, play on Google Chrome using a stable internet connection.",
  ];

  const knockoutTournamentRules = [
    "Register for the tournament before registrations close.",
    "Once the tournament begins, you'll be automatically matched with an opponent.",
    "Points are awarded as follows:",
    "🏆 Win: You earn 1 point for every coin left with your opponent at the end of the match, plus 3 bonus points if you pocket the Queen.",
    "❌ Loss: 0 points.",
    "Join your scheduled Carrom match within 10 minutes of the scheduled start time.",
    "Pocket all your assigned coins and the Queen (as per the game rules) before your opponent to win the match.",
    "If a player fails to join within the 10 minute grace period, they will forfeit the match, and their opponent will automatically advance to the next round.",
    "Continue winning each round to progress through the tournament bracket.",
    "🏆 Win the Final to become the Tournament Champion!",
    "If you pocket your opponent’s last coin while the Queen is still on the board, your opponent wins.",
    "If your opponent accidentally pockets your final cover coin while you are covering the Queen, leaving you with no coins, you win.",
    "If you pocket your last coin before covering the Queen, your opponent wins.",
    "If both colours are cleared in the same shot, the player taking the shot wins.",
    "If only one colour is cleared, the player who owns that colour wins, provided the Queen has been validly pocketed and covered.",
    "If you clear all your coins without the Queen being validly pocketed and covered, your opponent wins.",
    "Important:",
    "The system's decision will be final in all cases.",
    "For the best experience, please play using Google Chrome on a stable internet connection.",
  ];

  useEffect(() => {
    if (!themeData) return;
    if (apiGametype === 'live') {
      setRules(themeData.rules_live || themeData.rules || []);
    } else if (apiGametype === 'tournament') {
      if (tournamentType === 'Smart Tournament') {
        setRules(smartTournamentRules);
      } else if (tournamentType === 'knockout') {
        setRules(knockoutTournamentRules);
      } else {
        setRules(themeData.rules_tournament || themeData.rules || []);
      }
    } else {
      setRules(themeData.rules || []);
    }
 
  }, [apiGametype, themeData, tournamentType]);

  useEffect(() => {
    if (themeData != null) {
      const body = document.body;

      if (body.classList.contains('common-bg')) {
        // Check if it's a mobile device (or you can define your own breakpoint)
        if (window.innerWidth <= 768) {
          // Apply mobile background
          console.log(themeData.background_mob);
          body.style.backgroundImage = `url(${themeData.background_mob})`;
        } else {
          // Apply desktop background
          console.log(themeData.background_desk);
          body.style.backgroundImage = `url(${themeData.background_desk})`;
        }
      }
      SetriddlerusLogo(themeData.logo);
    }
  }, [themeData]);

 

  const handleNextClick = () => {

    navigate('/userpage');
  };

  const isTournament = apiGametype === 'tournament';
  const importantIndex = isTournament
    ? rules.findIndex((rule) => typeof rule === 'string' && rule.trim().toLowerCase().startsWith('important'))
    : -1;
  const listRules = importantIndex >= 0 ? rules.slice(0, importantIndex) : rules;
  const importantRules = importantIndex >= 0 ? rules.slice(importantIndex) : [];

  return (
    <>
      <div className="intro-main-container" style={{ textAlign: "center" }}>
        <div className="intro-main-container1" style={{ textAlign: "center" }}>
          <img src={riddlerusLogo} className="login-logo" />
        </div>

        <div className="text-main-container" style={{ textAlign: "center" }}>
          <h4 style={{ color: textcolor }} id="introtext">RULES</h4>
        </div>

        <div>
          <ul className="rules">
            {listRules.map((rule, index) => (
              <li style={{ color: textcolor }} key={index}>{rule || "N/A"}</li> // Show "N/A" if rule is empty
            ))}
          </ul>

          {importantRules.length > 0 && (
            <div className="rules-important" style={{ color: textcolor }}>
              {importantRules.map((rule, index) => (
                <p className="rules-important-line" key={index}>{rule}</p>
              ))}
            </div>
          )}
        </div>

        <div style={{ textAlign: "center" }}>
          <img 
            src="/img/next-button.png" 
            className="begin-play-img" 
            onClick={handleNextClick}
            style={{ cursor: 'pointer' }}
            alt="Next"
          />
        </div>
      </div>

    </>

  );
}
export default Intro;